
import { RevLink } from '@ds/components/Link'

import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import translations from './Footer.translations'

export default {
  components: {
    RevLink,
  },
  props: {
    footer: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    translations: () => translations,
  },

  methods: {
    sendMarketingData(displayName) {
      trackClick({
        name: 'discover_our_articles',
        zone: ROUTES.BUYING_GUIDE.HUB,
        value: {
          articleName: displayName,
        },
      })
    },
  },
}
